






























import Vue, { VueConstructor } from "vue";
import VaSwitch from "@/components/atoms/VaSwitch.vue";
import validationMixin from "@/components/mixins/validationMixin";
import policiesMixin from "@/components/mixins/policiesMixin";
import PresentationSetupSelector from "@/components/molecules/presentationOptions/PresentationSetupSelector.vue";

export default (
  Vue as VueConstructor<
    Vue &
      InstanceType<typeof policiesMixin> &
      InstanceType<typeof validationMixin>
  >
).extend({
  name: "DisplayConfiguration",
  components: { VaSwitch, PresentationSetupSelector },
  mixins: [validationMixin, policiesMixin],
  methods: {
    selectSetup(val: number) {
      this.fields.PresentationSetupMode = val;
      this.onChange();
    },
  },
});
